<template>
  <CockpitDialog
    :title="topTitle"
    @close="closeAlarmList"
    :top="'150px'"
    :left="'400px'"
    :width="'1100px'"
    :height="'600px'"
  >
    <div class="w-full h-[calc(100%-40px)] relative flex">
      <div class="w-3/5 h-full">
        <MonitorPlayer
          v-if="currentMonitor"
          :manufacturerCode="currentMonitor.manufacturerCode"
          :daHuaParams="{
            id: currentMonitor.id,
            code: currentMonitor.code,
          }"
          :code="currentMonitor.code"
          :name="currentMonitor.name"
          :pIid="currentMonitor.pIid"
          :showControlPanel="false"
          class="h-210px mt-15px"
        />
        <div class="flex items-center justify-center w-full h-full text-20px text-gray-600" v-else>
          当前附近无视频
        </div>
      </div>
      <div class="w-2/5 h-full">
        <el-table :data="cameraList" height="100%">
          <el-table-column
            label="附近摄像头名称"
            prop="name"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="距离" prop="distance" width="80px" show-overflow-tooltip>
            <template slot-scope="scope"> {{ scope.row.distance }}m </template>
          </el-table-column>
          <el-table-column label="操作" width="60px">
            <template slot-scope="scope">
              <span class="w-15 cursor-pointer text-[#00BCC8]" @click="currentMonitor = scope.row">
                查看
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-button
        size="small"
        type="primary"
        class="absolute top-[-50px] right-450px"
        @click="
          settingVisible = true
          form.advice = ''
        "
        >处理</el-button
      >
    </div>
    <CockpitDialog
      v-if="settingVisible"
      title="设置接收报警通知"
      @close="settingVisible = false"
      :top="'300px'"
      :left="'625px'"
      :width="'600px'"
      :height="'350px'"
    >
      <el-form :model="form" ref="formRef">
        <el-form-item
          label="处理意见"
          label-width="100px"
          prop="advice"
          :rules="[{ required: true, message: '请填写处理意见', trigger: ['change', 'blur'] }]"
        >
          <el-input
            v-model="form.advice"
            type="textarea"
            :rows="8"
            placeholder="请输入处理意见"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <span class="flex justify-center">
        <el-button type="primary" @click="submitOpinion">
          保存
        </el-button>
        <el-button @click="settingVisible = false">取消</el-button>
      </span>
    </CockpitDialog>
  </CockpitDialog>
</template>

<script>
import { StandardAlarmRecordApi } from '@wiz-api/personnel-position'
import { PersonnelLocationApi } from '@wiz-api/huizhou2'
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import { Tag3DCameraPositionsApi } from '@wiz-api/iot-device-management'

const tag3DCameraPositionsApi = new Tag3DCameraPositionsApi()
const alarmRecordApi = new StandardAlarmRecordApi()
const personnelLocationApi = new PersonnelLocationApi()
const MonitorPlayer = () => {
  return import('./video/MonitorPlayer')
}
export default {
  components: {
    CockpitDialog,
    MonitorPlayer,
  },
  props: {
    alarmCameraVisible: {
      type: Boolean,
      default: false,
    },
    alarmInfo: {
      type: Object,
      default: () => {
        return {}
      },
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      topTitle: '报警',
      settingVisible: false,
      cameraList: [],
      currentMonitor: null,
      form: {
        advice: '',
      },
    }
  },
  created() {
    this.getNearbyCamera()
  },
  methods: {
    async submitOpinion() {
      await this.$refs.formRef.validate()
      const [err, res] = await alarmRecordApi.confirmAlarm(this.alarmInfo.id, {
        advice: this.form.advice,
      })
      if (!err) {
        this.$message.success(this.$t('处理成功'))
        this.settingVisible = false
        this.$emit('loadAlarm')
        this.closeAlarmList()
      }
    },
    // 获取附近摄像头
    async getNearbyCamera() {
      this.topTitle =
        this.alarmInfo.personNames + this.alarmInfo.alarmTypeName + this.alarmInfo.fenceName
      const [err, res] = await tag3DCameraPositionsApi.getNearbyCameras({
        x: this.alarmInfo.position[0],
        y: this.alarmInfo.position[1],
        _number: 5,
      })
      if (!err) {
        if (res.length && !isEqual(this.currentMonitor, res[0])) {
          this.cameraList = res.slice(0, 20)
          this.currentMonitor = null
          this.currentMonitor = res[0]
        } else {
          this.currentMonitor = null
        }
      }
    },
    closeAlarmList() {
      this.$emit('update:alarmCameraVisible', false)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/styles/table';

::v-deep .el-textarea__inner {
  color: var(--cockpitInputFontColor) !important;
  background-color: var(--cockpitInputBgColor) !important;
  border: 1px solid !important;
  border-color: var(--cockpitInputBorderColor) !important;

  &:hover {
    border-color: var(--cockpitInputHoverBorderColor) !important;
  }
}

::v-deep .el-textarea .el-input__count {
  font-size: 12px;
  color: var(--cockpitInputNumberCreaseColor);
  background: var(--cockpitInputNumberCreaseBg);
  border: none;
}
</style>
